import styles from '../styles/TechStack.module.css';

const STACK = [
  'React.js',
  'Node.js',
  'Express.js',
  'MongoDB',
  'WordPress',
  'PHP',
  'MySQL',
  'GSAP',
  'Three.js',
  'Socket.io',
  'Cloudflare',
  'CyberPanel',
];

export default function TechStack() {
  const items = [...STACK, ...STACK];

  return (
    <div className={styles.strip} aria-hidden="true">
      <div className={styles.track}>
        {items.map((item, i) => (
          <span className={styles.item} key={`${item}-${i}`}>
            {item}
            <span className={styles.dot} />
          </span>
        ))}
      </div>
    </div>
  );
}
